export enum Series {
  series01 = 'price',
  series02 = 'priceTarget',
  rangeTargetHigh = 'priceTargetRangeHigh',
  rangeTargetLow = 'priceTargetRangeLow',
}

export const filterSeries = (n: string) =>
  n === Series.series01 || n === Series.series02;

export const DEFAULT_FILTER = {
  price: true,
  priceTarget: true,
  priceTargetRangeHigh: true,
  priceTargetRangeLow: true,
};

type MinMaxPrices = {
  priceTargetMax: number;
  priceTargetMin: number;
  priceMax: number;
  priceMin: number;
};

export const findMinMax = (
  series: string[],
  { priceMin, priceMax, priceTargetMin, priceTargetMax }: MinMaxPrices
) => {
  const minMaxY = {
    [Series.series01]: [priceMin, priceMax],
    [Series.series02]: [priceTargetMin, priceTargetMax],
  };
  return series.reduce(
    ([min, max], series) => {
      const [newMin, newMax] = minMaxY[series];
      return [
        Math.min(...[newMin, min].filter(isFinite)),
        Math.max(...[newMax, max].filter(isFinite)),
      ];
    },
    [priceMin, priceMax]
  );
};
